import {
  FoundationDatumVerticalAnchor,
  HorizontalJustification,
  VerticalJustification,
  WallHorizontalDatum,
  WallVerticalDatumAnchor,
} from "building-types/datums/datumsTypesEnum";
import { foundationVerticalDatumEntityNew } from "doc/datums/datumEntityNew";
import {
  LegacyFoundationVerticalDatumAbstraction,
  LegacyWallHorizontalDatumAbstraction,
  LegacyWallVerticalDatumAbstraction,
} from "./datumAbstractions";
import { wallAssemblyHorizontalDatumNew, wallAssemblyVerticalDatumNew } from "./datumEntity";

export const defaultWallDatumAbstractions = {
  lowerDatum: new LegacyWallVerticalDatumAbstraction(
    wallAssemblyVerticalDatumNew(
      "Default Lower Datum",
      WallVerticalDatumAnchor.BASE_WALL,
      VerticalJustification.BOTTOM_UP,
    ),
  ),
  upperDatum: new LegacyWallVerticalDatumAbstraction(
    wallAssemblyVerticalDatumNew(
      "Default Upper Datum",
      WallVerticalDatumAnchor.BASE_WALL,
      VerticalJustification.TOP_DOWN,
    ),
  ),
  startDatum: new LegacyWallHorizontalDatumAbstraction(
    wallAssemblyHorizontalDatumNew(
      "Default Start Datum",
      WallHorizontalDatum.OUTSIDE_OF_SURFACE,
      HorizontalJustification.START_TO_END,
    ),
  ),
  endDatum: new LegacyWallHorizontalDatumAbstraction(
    wallAssemblyHorizontalDatumNew(
      "Default End Datum",
      WallHorizontalDatum.OUTSIDE_OF_SURFACE,
      HorizontalJustification.END_TO_START,
    ),
  ),
};

export const defaultFoundationDatumAbstractions = {
  bottomDatum: new LegacyFoundationVerticalDatumAbstraction(
    foundationVerticalDatumEntityNew({
      anchor: FoundationDatumVerticalAnchor.FOUNDATION,
    }),
  ),
};
